export interface WizardStepInfo {
  id: number;
  label: string;
  icon: string;
  description: string;
}

export const CREATE_FLOW_STEPS: WizardStepInfo[] = [
  {
    id: 1,
    label: 'File Information',
    icon: 'badge',
    description: 'Name your file and choose who can access it.',
  },
  {
    id: 2,
    label: 'Upload Data Source',
    icon: 'upload_file',
    description:
      'Upload your provider file in CSV, Excel, Parquet, Feather, IPC, or Arrow format and confirm it looks right.',
  },
  {
    id: 3,
    label: 'Map Columns',
    icon: 'table_chart',
    description:
      'Match your file columns to the expected fields, then continue to validation.',
  },
];

export const HOW_IT_WORKS_STEPS: WizardStepInfo[] = [
  {
    id: 1,
    label: 'New File',
    icon: 'upload_file',
    description:
      'Start a new file by uploading your provider data source in CSV, Excel, Parquet, Feather, IPC, or Arrow format.',
  },
  {
    id: 2,
    label: 'Map Columns',
    icon: 'table_chart',
    description: "Match your file's columns to the expected fields, then submit for validation.",
  },
  {
    id: 3,
    label: 'Open a File',
    icon: 'folder_open',
    description: 'Return anytime from the Files list to pick up where you left off.',
  },
  {
    id: 4,
    label: 'Review Matches',
    icon: 'fact_check',
    description:
      'Work through each provider row in the File Details — confirm, edit, or reject the suggested matches. Ask CADIX if you need help.',
  },
  {
    id: 5,
    label: 'Download Results',
    icon: 'download',
    description:
      'Once a file is complete, download the finished cross reference as a CSV.',
  },
];
